import React from 'react';
import { twMerge } from 'tailwind-merge';

export const singleCaption = (props) => {
  const data = JSON.parse(props.children);
  // const container =
  //   data.layout === 'full-width' ? 'block absolute left-0 h-48 mb-48' : '';
  const style = `figure-${data.layout} mt-3 pb-2 font-sans text-sm text-stone-600 border-b-2 border-b-stone-200`;

  return (
    <>
      {data.layout === 'regular' && (
        <div className={twMerge(style)}>
          <figcaption className="">{data.body}</figcaption>
        </div>
      )}
      {data.layout === 'extra-wide' && (
        <div className={twMerge(style)}>
          <figcaption className="">{data.body}</figcaption>
        </div>
      )}
      {data.layout === 'full-width' && (
        <div className="static mb-12 mt-24 h-[5vh]">
          <div className="not-prose absolute left-0 m-0 h-[5vh] w-screen overflow-hidden border-b-2 border-b-slate-400 bg-white pl-2 font-sans">
            <figcaption className="">{data.body}</figcaption>
          </div>
        </div>
      )}
    </>
  );
};
